export const adminDefault = '/admin/default';
export const authSignIn = '/auth/sign-in'